import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Pre = props => {
  const {
    className,
    use
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className", "use"]);

  return /*#__PURE__*/_jsx("pre", Object.assign({}, rest, {
    className: classNames(className, use === 'code' && 'private-pre--code')
  }));
};

Pre.propTypes = {
  use: PropTypes.oneOf(['default', 'code'])
};
Pre.defaultProps = {
  use: 'default'
};
Pre.displayName = 'Pre';
export default Pre;